import store from '@/store/store'

function setScrollTop(el, savedPosition) {
  el.scrollTop = savedPosition
  requestAnimationFrame(() => {
    el.scrollTop = savedPosition
  })
}

export const vSaveScroll = {
  mounted(el, {value: pageKey}) {

    let settings = null
    if (typeof pageKey === 'object') {
      settings = pageKey
      pageKey = settings.pageKey
    }

    if (!pageKey) {
      console.warn('v-save-scroll requires a page key')
      return
    }

    el._saveScroll = {
      store,
      pageKey,
    }
    const savedPosition = store.getters['savingData/getScrollPosition'](pageKey)

    // console.log('savedPosition', pageKey, savedPosition)

    if (savedPosition) {
      if (settings && settings.promise) {
        settings.promise.then(() => setScrollTop(el, savedPosition))
        return
      }

      setScrollTop(el, savedPosition)
    }
  },

  beforeUnmount(el) {
    if (!el._saveScroll) return

    const {store, pageKey} = el._saveScroll

    // console.log('savePosition', pageKey, el.scrollTop)

    store.dispatch('savingData/saveScrollPosition', {
      pageKey,
      position: el.scrollTop
    })

    delete el._saveScroll
  }
}
